import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FETCH_EVOPLAY_SESSIONS,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'evoplaysession' })
export default class EvoplaySession extends VuexModule {
  @Action
  FindSessions(username: string) {
    return Vue.axios({
      url: BASE_URL + FETCH_EVOPLAY_SESSIONS,
      method: M_POST,
      data: username,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
